import {dispatchAction} from './actions';

export const ActionLogger = store => {
    return next => {
        return action => {
            dispatchAction(action, store);
            const result = next(action);
            return result;
        }
    }
};


// WEBPACK FOOTER //
// ./src/middleware/ActionLogger/ActionLogger.js